import { Helmet } from "react-helmet";
import Navbar from "../components/universal/navbar";
import Header from "../components/patient-stories/hero";
import About from "../components/patient-stories/about";
import Gallery from "../components/patient-stories/gallery";
import Testimonials from "../components/universal/testimonials";
import Contact from "../components/universal/contact";
import Footer from "../components/universal/footer";

function Index() {
  return (
    <div>
      <Helmet>
        <title>Patient Success Stories Before & After | Regent Dental</title>
        <meta
          name="description"
          content="Read real patient stories from Regent Dental in West Yorkshire. Discover how we’ve helped people smile with confidence through expert, caring dental treatment."
        />
        <link
          rel="canonical"
          href="https://www.regent-dental.co.uk/patient-stories"
        />
      </Helmet>
      <Navbar />
      <Header />
      <About />
      <Gallery />
      <Testimonials />
      <Contact />
      <Footer />
    </div>
  );
}

export default Index;
